export const IMPORTER_ERROR_CODES = {
  DATA_ERROR: 'CSV0004',
  EMPTY_CSV: 'CSV0006',
  INCOMPLETE: 'CSV0007',
  WRONG_FILE_TYPE: 'WRONG_FILE_TYPE',
  PRO_SEAT_LIMIT_EXCEEDED: 'PRO_SEAT_LIMIT_EXCEEDED',
} as const

export const ACCEPTED_CSV_FILE_TYPES = ['.csv', 'application/csv', 'text/csv']

export const ACCEPTED_ZIP_MIME_TYPES = [
  'application/zip',
  'application/x-zip-compressed',
]

export const CSV_LABEL = 'CSV'
export const ZIP_LABEL = 'ZIP'

export * from './ImporterOptions'
